export schema from './schema'
export model from './model'
export hook from './hook'
export menus from './menus'
export config from '@/config'
export router from '@/router'
console.log('56')
